query PaymentSearchHints(
  $paymentSearchRequest: SearchRequestInput!
  $isLinkSearch: Boolean
  $isHistorySearch: Boolean
) {
  paymentSearchHints(
    searchRequest: $paymentSearchRequest
    isLinkSearch: $isLinkSearch
    isHistorySearch: $isHistorySearch
  ) {
    nodes {
      id
      caption
      linkType
      resultsCount
    }
  }
}
